var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import useEnteredViewport from "core/customHooks/useEnteredViewport";
import { config } from "core/utils";
import { config as _config } from "./config";
export var useImpressionTracking = function (info, skip) {
    var _a = useEnteredViewport(config.tracking.impressionThreshold.default), ref = _a.ref, enteredViewport = _a.enteredViewport;
    if (skip || !enteredViewport)
        return ref;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "product_impression",
        ecommerce: {
            impressions: [__assign({ list: _config.trackingList }, info)],
        },
    });
    return ref;
};
